export default __webpack_public_path__ + "static/media/HHLogo.51f33f03.png";